import { render, staticRenderFns } from "./ContractSortScaleSummary.vue?vue&type=template&id=2139bb6c&scoped=true&"
import script from "./ContractSortScaleSummary.vue?vue&type=script&lang=js&"
export * from "./ContractSortScaleSummary.vue?vue&type=script&lang=js&"
import style0 from "./ContractSortScaleSummary.vue?vue&type=style&index=0&id=2139bb6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2139bb6c",
  null
  
)

export default component.exports